import { EnvironmentKey } from '../types/enviromentType';
const stackNumber: Record<number, EnvironmentKey> = {
  0: 'dev',
  1: 'pie',
  2: 'stage',
  3: 'prod'
};

const stackMap = (stack: number): EnvironmentKey => {
  return stackNumber[stack];
};

export const getStack = (stack: number | string): EnvironmentKey => {
  return typeof stack === 'number'
    ? stackMap(stack)
    : (stack as EnvironmentKey);
};
